import axiosSmartSurvey from "../../../api/axios"

export default function useFetchSurveyData() {
    async function fetchSurveyBuilding(parcelCode, setSurveyBuildings, setSurveyBuildingLoading) {
        try {
            setSurveyBuildingLoading(true);

            const response = await axiosSmartSurvey.post('/map/surveymapinfo', {
                parcelCode: parcelCode
            });

            if (response?.data?.status === 'OK' && Array.isArray(response.data.surveyBuildings)) {
                setSurveyBuildings(response.data.surveyBuildings);
            } else {
                // console.warn('⚠️ fetchSurveyBuilding: unexpected response format', response?.data);
                setSurveyBuildings([]); // reset ในกรณีไม่มีข้อมูล
            }
        } catch (error) {
            console.error('🚨 fetchSurveyBuilding error:', error);
            setSurveyBuildings([]); // reset ในกรณี error
        } finally {
            // ปิด loading ไม่ว่าผลลัพธ์จะเป็นยังไง
            setSurveyBuildingLoading(false);
        }
    }
    
    async function fetchSurveyImages(parcelCode, setLandImagesUrl, setBuildingImagesURL, setSurveyImagesLoading) {
        try {
            setSurveyImagesLoading(true);
            setLandImagesUrl([]);
            setBuildingImagesURL([]);

            // 🔹 ดึงรายการภาพจากเซิร์ฟเวอร์
            const { data } = await axiosSmartSurvey.post('/upload/requestimageid', {
                parcelCode
            });

            const landImages = data?.landImages || [];
            const buildingImages = data?.buildingImages || [];

            // 🔹 โหลดภาพทั้งหมดแบบขนาน
            const landPromises = landImages.map(img => fetchImage(img, 'land', setLandImagesUrl));
            const buildingPromises = buildingImages.map(img => fetchImage(img, 'building', setBuildingImagesURL));

            // ✅ รอให้ทุกภาพโหลดเสร็จก่อนปิด loading
            await Promise.all([...landPromises, ...buildingPromises]);

        } catch (err) {
            console.error('🚨 fetchSurveyImages error:', err);
        } finally {
            setSurveyImagesLoading(false);
        }
    }

    // === ฟังก์ชันย่อยสำหรับโหลดภาพแต่ละไฟล์ ===
    async function fetchImage(imageData, type, setFn) {
        try {
            const res = await axiosSmartSurvey.post(
                '/upload/downloadimages',
                { path: imageData.path },
                { responseType: 'blob' }
            );

            const url = URL.createObjectURL(res.data);
            const imageObj = {
                url,
                parcelCode: imageData.parcelCode,
                uploadDate: imageData.uploadDate,
                ...(type === 'land'
                    ? { dn: imageData.dn }
                    : { address: imageData.address })
            };

            // 🔹 เพิ่มภาพใหม่เข้า state แบบสะสม
            setFn(prev => [...prev, imageObj]);

        } catch (error) {
            console.error(`❌ Error downloading ${type} image:`, error);
        }
    }

    // async function fetchSurveyImages(parcelCode, setLandImagesUrl, setBuildingImagesURL, setSurveyImagesLoading) {
    //     //ต้องแก้ API ให้ทำงานครั้งเดียวบนเซิร์ฟเวอร์
    //     setSurveyImagesLoading(true)
    //     setLandImagesUrl([])
    //     setBuildingImagesURL([])
    //     await axiosSmartSurvey({
    //         method: 'post',
    //         url: `/upload/requestimageid`,
    //         data: {
    //             parcelCode: parcelCode
    //         }
    //     }).then(async response => {
    //         response = response.data
    //         if (response?.landImages?.length > 0) {
    //             // console.log(response.landImages)
    //             const landImages = response.landImages
    //             await landImages?.forEach(async (landImage) => {
    //                 await fetchImage(landImage, 'land', setSurveyImagesLoading)
    //             })
    //         }
    //         if (response?.buildingImages?.length > 0) {
    //             // console.log(response.buildingImages)
    //             const buildingImages = response.buildingImages
    //             // console.log(buildingImages)
    //             await buildingImages?.forEach(async (buildingImage) => {
    //                 // console.log(buildingImage)
    //                 await fetchImage(buildingImage, 'building', setSurveyImagesLoading)
    //             })
    //         }
    //         if (!(response?.landImages?.length > 0 || response?.buildingImages?.length > 0)) {
    //             setSurveyImagesLoading(false)
    //         }
    //     }).catch((err) => {
    //         setSurveyImagesLoading(false)
    //         console.log(err)
    //     })
    //     async function fetchImage(imagesData, type, setSurveyImagesLoading) {
    //         await axiosSmartSurvey({
    //             method: 'post',
    //             url: `/upload/downloadimages`,
    //             data: {
    //                 path: imagesData.path
    //             },
    //             responseType: 'blob'
    //         }).then(async response => {
    //             // console.log(imagesURL)
    //             if (type === 'land') {
    //                 const imagesURL = {
    //                     url: URL.createObjectURL(response.data),
    //                     parcelCode: imagesData.parcelCode,
    //                     uploadDate: imagesData.uploadDate,
    //                     dn: imagesData.dn
    //                 }
    //                 setLandImagesUrl(prev => [...prev, imagesURL])
    //             }
    //             if (type === 'building') {
    //                 const imagesURL = {
    //                     url: URL.createObjectURL(response.data),
    //                     parcelCode: imagesData.parcelCode,
    //                     uploadDate: imagesData.uploadDate,
    //                     address: imagesData.address
    //                 }
    //                 // console.log(imagesURL)
    //                 setBuildingImagesURL(prev => [...prev, imagesURL])
    //             }
    //             setSurveyImagesLoading(false)
    //         }).catch(error => {
    //             console.error(error);
    //             setSurveyImagesLoading(false)
    //         })
    //     }
    // }
    return { fetchSurveyBuilding, fetchSurveyImages }
}
